import { Pipe, PipeTransform } from '@angular/core';
import { CarrierTrackingService } from '../../services/carrier-tracking.service';

@Pipe({
	name: 'trackingUrl',
	pure: true,
})
export class TrackingUrlPipe implements PipeTransform {
	constructor(private readonly carrier: CarrierTrackingService) {}

	transform(
		trackingNumber: string | null | undefined,
		shipperName?: string | null,
		override?: string | null,
		shipperTemplateUrl?: string | null,
	): string | null {
		return this.carrier.getTrackingUrl(trackingNumber, shipperName, override, shipperTemplateUrl);
	}
}
